export const largeChartFontSize = {
  S: 8,
  M: 10,
  XXL: 16,
  XXXL: 24,
}
